<template>
  <tbody class="default-table-body" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </tbody>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table-body {
  /* Adicione estilos específicos para a célula da tabela aqui, se necessário */
}
</style>
